// src/pages/CourseTime/utils/sessionUtils.js
import { SEGMENT_LABELS } from '../../../utils/constants';
import { GET_APP_LOCALIZE_TEXT } from '../../../utils/dq_lc_service/lc_service';

// Map static segment keys to translation keys
const SEGMENT_STATIC_LC_KEYS = {
  Seg1: 'ct__segment_introduction',
  // Newer content's keys (preview: getSegmentDisplayName).
  Intro: 'ct__segment_introduction',
  Closing: 'ct__segment_recap',
  Seg1_1: 'ct__segment_pre_assessment',
  Seg4: 'ct__segment_reflection',
  Seg4_1: 'ct__segment_post_assessment',
  Seg5: 'ct__segment_recap',
  Seg5_1: 'ct__segment_session_score'
};

// Helper function to get segment label with fallback (locale from caller, e.g. pageLc)
export const getSegmentLabel = (segmentKey, sloTitles, locale) => {
  // First try to get from slo_titles if available
  if (sloTitles && sloTitles[segmentKey] && sloTitles[segmentKey].trim() !== '') {
    return sloTitles[segmentKey];
  }

  // Static segment names: use translations when locale is provided
  const lcKey = SEGMENT_STATIC_LC_KEYS[segmentKey];
  if (lcKey && locale) {
    return GET_APP_LOCALIZE_TEXT(locale, lcKey);
  }
  if (lcKey) {
    return SEGMENT_LABELS[segmentKey] || segmentKey;
  }

  // Fallback to SEGMENT_LABELS (e.g. SLO placeholders)
  return SEGMENT_LABELS[segmentKey] || segmentKey;
};

export const getSloTitlesForSession = (session) => {
  // Handles both old and new data shape, expects array of SLOs
  if (!session?.session_learning_objectives) return {};
  const sloTitles = {};
  session.session_learning_objectives.forEach((slo, idx) => {
    sloTitles[`SLO${idx+1}`] = slo.slo_title || `SLO${idx+1}`;
  });
  return sloTitles;
};

export const getSegmentDisplayName = (segmentKey, session, locale) => {
  if (segmentKey.startsWith("SLO")) {
    // Dynamically fetch SLO title from session object
    const sloTitles = getSloTitlesForSession(session);
    return sloTitles[segmentKey] || segmentKey;
  }

  const lcKey = SEGMENT_STATIC_LC_KEYS[segmentKey];
  if (lcKey && locale) {
    return GET_APP_LOCALIZE_TEXT(locale, lcKey);
  }
  if (lcKey) {
    return SEGMENT_LABELS[segmentKey] || segmentKey;
  }
  return segmentKey;
};
